import { Component, Input } from "@angular/core";

@Component({
    selector: "ds-empty-state",
    imports: [],
    templateUrl: "./empty-state.component.html",
    styleUrl: "./empty-state.component.scss"
})
export class EmptyStateComponent {
  @Input() icon = "tio-selection";
  @Input() title = "Nothing here... yet!";
  @Input() description = "Start by exploring the available options to bring this space to life.";
}
